module.exports = __webpack_public_path__ + "img/szh3.15256c12.jpg";